/**
 * TermsModal - 약관 팝업 모달
 * 🔥 버튼 디자인 개선
 * 🔥 onConfirm prop 추가 - 확인 버튼 클릭 시 자동 동의 체크
 * 🌍 다국어 지원 - confirmText, closeText props 추가
 */
import React from 'react';
import { X, Check } from 'lucide-react';
import './TermsModal.css';

const TermsModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  content,
  confirmText = '확인 및 동의',  // 기본값 (한국어)
  closeText = '닫기'              // 기본값 (한국어)
}) => {
  if (!isOpen) return null;

  // 확인 버튼 클릭 핸들러
  const handleConfirm = () => {
    // onConfirm이 전달되었으면 호출 (동의 체크 처리)
    if (onConfirm) {
      onConfirm();
    }
    // 모달 닫기
    onClose();
  };

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* 헤더 */}
        <div className="terms-modal-header">
          <h3>{title}</h3>
          <button className="terms-close-btn" onClick={onClose} aria-label={closeText}>
            <X size={20} />
          </button>
        </div>

        {/* 본문 */}
        <div className="terms-modal-body">
          <pre className="terms-text">{content}</pre>
        </div>

        {/* 푸터 - 확인 버튼 클릭 시 동의 체크 */}
        <div className="terms-modal-footer">
          <button className="terms-confirm-btn" onClick={handleConfirm}>
            <Check size={18} />
            <span>{confirmText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;